import { useSettings } from '@capsicum/common';
import { useRouter } from '@capsicum/common-web';
import { useEffect } from 'react';

export const useAuctionsGuard = () => {
	const { replace } = useRouter();
	const { settings } = useSettings();

	useEffect(() => {
		if (!settings?.isRewardPointAuctionsEnabled) {
			replace('/fan-shop/rewards?tab=fan-rewards');
		}
	}, [replace, settings?.isRewardPointAuctionsEnabled]);
};

export const useRPAuctionsGuard = () => {
	const { replace } = useRouter();
	const { settings } = useSettings();

	useEffect(() => {
		if (!settings?.isRewardPointAuctionsEnabled) {
			replace('/fan-shop/rewards?tab=fan-rewards');
		}
	}, [replace, settings?.isRewardPointAuctionsEnabled]);
};

export const useFanRewardsGuard = () => {
	const { replace } = useRouter();
	const { settings } = useSettings();

	useEffect(() => {
		if (!settings?.isFanRewardEnabled) {
			replace('/fan-shop/rewards?tab=auctions');
		}
	}, [replace, settings?.isFanRewardEnabled]);
};
